export default (field) => field.sys.contentType.sys.id;
